import {Box, Center, Flex, ResponsiveValue, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {useTranslation} from 'hooks';
import React, {FC} from 'react';
import ImageUI from 'ui/ImageUI';

interface IProps {
  ratingsCount?: string;
  deliveryTime?: string;
  hasPreorder?: boolean;
  styles?: Record<string, any>;
  separateFewRatings?: boolean;
  maxW?: ResponsiveValue<string>;
}

export const BreadcrumbLine: FC<IProps> = React.memo(
  ({ratingsCount, deliveryTime, hasPreorder, styles, separateFewRatings, maxW}) => {
    const {t} = useTranslation();

    const textSize = styles?.textSize ?? ['12px', '13px'];
    const ratingNumber = parseFloat(ratingsCount ?? '0');

    const ratingEmojy =
      ratingNumber < 3.99
        ? '🥺'
        : ratingNumber >= 3.99 && ratingNumber <= 4.29
        ? ' 😌'
        : ratingNumber >= 4.3
        ? ' 🤩'
        : '';
    return (
      <Flex color={colors.black} justify="space-between" alignItems="center" maxW={maxW || ['360px', '320px']}>
        <Flex alignItems="center">
          {deliveryTime && (
            <Center>
              <ImageUI src="/car.svg" width="15px" height="15px" mr="2px" />
              <Text as="span" whiteSpace="nowrap" fontSize={textSize} fontWeight="normal">
                {deliveryTime} {!hasPreorder && t('MINUTES')}
              </Text>
            </Center>
          )}
        </Flex>
        <Box>
          <Text pt={ratingNumber ? '0' : '2px'} pl={1} fontSize={textSize} fontWeight="normal">
            {ratingNumber
              ? `${ratingEmojy} ${ratingNumber.toFixed(2)}`
              : `${separateFewRatings ? ' • ' : ''} ${t('fewRatings')}`}
          </Text>
        </Box>
      </Flex>
    );
  },
);
